import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AdminLayout from '../layout/AdminLayout';
import ForeignOrderPackage from '../components/foreign/ForeignOrderPackage';
import { ForeignOrderPackageDetail } from '../components/foreign/ForeignOrderPackageDetail';
import { CustomerDelivery } from '../components/customer/CustomerDelivery';
import { CustomsDetail } from '../components/foreign/CustomsDetail';
import ForeignOrderCustoms from '../components/foreign/ForeignOrderCustoms';
import { AddressList } from '../components/settings/address/AddressList';
import BranchList from '../components/settings/branch/BranchList';
import { DeliveryTime } from '../components/settings/delivery/DeliveryTime';
import { SortingView } from '../components/settings/sorting/SortingView';
import { Login } from '../components/login/Login';
import Home from '../components/Home';
import BranchUpdate from '../components/settings/branch/BranchUpdate';
import { CustomerList } from '../components/settings/customer/CustomerList';
import BranchAddress from '../components/settings/branch/BranchAddress';
import { ShipmentStatusList } from '../components/settings/status/ShipmentStatusList';
import { ForeignOrderList } from '../components/foreign/ForeignOrderList';
import BranchStaff from '../components/settings/branch/BranchStaff';
import AreaList from '../components/settings/area/AreaList';
import AreaAddressList from '../components/settings/area/AreaAddressList';
import CustomerUpdate from '../components/settings/customer/CustomerUpdate';
import TariffList from '../components/settings/tariff/TariffList';
import TariffUpdate from '../components/settings/tariff/TariffUpdate';
import BranchDeliveryMan from '../components/settings/branch/BranchDeliveryMan';
import CustomerStaff from '../components/settings/customer/CustomerStaff';
import BranchStaffUpdate from '../components/settings/branch/BranchStaffUpdate';
import OrderList from '../components/order/OrderList';
import BranchDeliveryManUpdate from '../components/settings/branch/BranchDeliveryManUpdate';
import CustomerStaffUpdate from '../components/settings/customer/CustomerStaffUpdate';
import EmptyPage from '../components/EmptyPage';
import OrderUpdate from '../components/order/OrderUpdate';
import OrderBatch from '../components/order/OrderBatch';
import OrderDraft from '../components/orderDraft/OrderDraft';
import OrderDraftTransport from '../components/orderDraft/OrderDraftTrasport';
import OrderDraftPackage from '../components/orderDraft/OrderDraftPackage';
import OrderDetail from '../components/order/OrderDetail';
import OrderCancel from '../components/order/OrderCancel';
import OrderPending from '../components/order/OrderPending';
import DeliveryView from '../components/delivery/DeliveryView';
import Dashboard from '../components/dashboard/Dashboard';
import OrderSearchView from '../components/order/OrderSearchView';
import { useContext } from 'react';
import { UserContext } from '../context/UserProvider';
import CustomerLayout from '../layout/CustomerLayout';
import PageList from '../components/settings/page/PageList';
import BarcodeSettingsList from '../components/settings/barcode/BarcodeSettingsList';
import CustomOrderLayout from '../layout/CustomOrderLayout';
import CustomOrderList from '../components/custom/CustomOrderList';
import CustomOrderView from '../components/custom/CustomOrderView';
import Payment from '../components/custom/Payment';
import Tracking from '../components/track/Tracking';
import { AddressNew } from '../components/settings/address/AddressNew';
import { ShippingReport } from '../components/report/ShippingReport';
import ShippingStatusReport from '../components/report/ShippingStatusReport';
import { ForeignTransport } from '../components/foreign/ForeignTransport';
import { ForeignTransportDetail } from '../components/foreign/ForeignTransportDetail';
import OptionList from '../components/options/OptionList';
import DashboardCustoms from '../components/dashboard/DashboardCustoms';
import Profile from '../components/profile/Profile';

const XpressRouter = () => {
  const { getCustomer, isCustomsRole } = useContext(UserContext);
  if (isCustomsRole) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<AdminLayout />}>
            <Route index element={<DashboardCustoms />} />
          </Route>
          <Route path="/profile" element={<AdminLayout />}>
            <Route index element={<Profile />} />
          </Route>
          <Route path="order_draft" element={<AdminLayout />}>
            <Route path="transports" element={<OrderDraftTransport />} />
            <Route path="packages" element={<OrderDraftPackage />} />
            <Route path="parcels" element={<OrderDraft />} />
          </Route>
          <Route path="foreign" element={<AdminLayout />}>
            <Route path="order" element={<ForeignOrderList />} />
            <Route path="package" element={<ForeignOrderPackage />} />
            <Route path="package/detail/:no" element={<ForeignOrderPackageDetail />} />
            <Route path="customs" element={<ForeignOrderCustoms />} />
            <Route path="customs/:airBill" element={<CustomsDetail />} />
            <Route path="transports" element={<ForeignTransport />} />
            <Route path="transports/:manifestNumber" element={<ForeignTransportDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
    );
  }
  if (getCustomer) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth/login" element={<Login />} />
          <Route path="/dashboard" element={<CustomerLayout />}>
            <Route index element={<Dashboard />} />
          </Route>
          <Route path="/profile" element={<CustomerLayout />}>
            <Route index element={<Profile />} />
          </Route>
          <Route path="order" element={<CustomerLayout />}>
            <Route path="new" element={<OrderUpdate />} />
            <Route path="update/:orderNo" element={<OrderUpdate />} />
            <Route path="detail/:orderNo" element={<OrderDetail />} />
            <Route path="list" element={<OrderList />} />
            <Route path="search" element={<OrderSearchView />} />
            <Route path="batch" element={<OrderBatch />} />
          </Route>
          <Route path="delivery" element={<CustomerLayout />}>
            <Route path=":parcelStatusCd" element={<DeliveryView />} />
          </Route>
          <Route path="report" element={<CustomerLayout />}>
            <Route path="shipping" element={<ShippingReport />} />
          </Route>
          <Route path="customer" element={<CustomerLayout />}>
            <Route path="delivery" element={<CustomerDelivery />} />
          </Route>
          <Route path="*" element={<CustomerLayout />}>
            <Route path="*" element={<EmptyPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    );
  } else {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/track" element={<Tracking />} />
          <Route path="/customer-order" element={<CustomOrderLayout />}>
            <Route index element={<CustomOrderView />} />
            <Route path="list" element={<CustomOrderList />} />
            <Route path="payment/:paymentNo" element={<Payment />} />
          </Route>
          <Route path="/auth/login" element={<Login />} />
          <Route path="/dashboard" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
          </Route>
          <Route path="/profile" element={<AdminLayout />}>
            <Route index element={<Profile />} />
          </Route>
          <Route path="order" element={<AdminLayout />}>
            <Route path="new" element={<OrderUpdate />} />
            <Route path="update/:orderNo" element={<OrderUpdate />} />
            <Route path="detail/:orderNo" element={<OrderDetail />} />
            <Route path="list" element={<OrderList />} />
            <Route path="cancel" element={<OrderCancel />} />
            <Route path="pending" element={<OrderPending />} />
            <Route path="batch" element={<OrderBatch />} />

            <Route path="search" element={<OrderSearchView />} />
          </Route>
          <Route path="order_draft" element={<AdminLayout />}>
            <Route path="transports" element={<OrderDraftTransport />} />
            <Route path="packages" element={<OrderDraftPackage />} />
            <Route path="parcels" element={<OrderDraft />} />
          </Route>
          <Route path="foreign" element={<AdminLayout />}>
            <Route path="order" element={<ForeignOrderList />} />
            <Route path="package" element={<ForeignOrderPackage />} />
            <Route path="package/detail/:no" element={<ForeignOrderPackageDetail />} />
            <Route path="customs" element={<ForeignOrderCustoms />} />
            <Route path="customs/:airBill" element={<CustomsDetail />} />
            <Route path="transports" element={<ForeignTransport />} />
            <Route path="transports/:manifestNumber" element={<ForeignTransportDetail />} />
          </Route>
          <Route path="delivery" element={<AdminLayout />}>
            <Route path=":parcelStatusCd" element={<DeliveryView />} />
          </Route>
          <Route path="customer" element={<CustomerLayout />}>
            <Route path="delivery" element={<CustomerDelivery />} />
          </Route>
          <Route path="report" element={<AdminLayout />}>
            <Route path="shipping" element={<ShippingReport />} />
            <Route path=":status" element={<ShippingStatusReport />} />
          </Route>
          <Route path="settings" element={<AdminLayout />}>
            <Route path="delivery">
              <Route path="time" element={<DeliveryTime />} />
            </Route>
            <Route path="options" element={<OptionList />} />
            <Route path="customer" element={<CustomerList />} />
            <Route path="page" element={<PageList />} />
            <Route path="barcode" element={<BarcodeSettingsList />} />
            <Route path="customer/create" element={<CustomerUpdate />} />
            <Route path="customer/update/:customerNo" element={<CustomerUpdate />} />
            <Route path="customer/staff" element={<CustomerStaff />} />
            <Route path="customer/staff/create" element={<CustomerStaffUpdate />} />
            <Route path="customer/staff/update/:memberNo" element={<CustomerStaffUpdate />} />

            <Route path="address" element={<AddressNew />}></Route>
            <Route path="shipment_status" element={<ShipmentStatusList />} />
            <Route path="branch" element={<BranchList />} />
            <Route path="branch/update/:branchId" element={<BranchUpdate />} />
            <Route path="branch/address/:branchId" element={<BranchAddress />} />
            <Route path="branch/create" element={<BranchUpdate />} />
            <Route path="branch/staff" element={<BranchStaff />} />
            <Route path="branch/staff/create" element={<BranchStaffUpdate />} />
            <Route path="branch/staff/update/:memberNo" element={<BranchStaffUpdate />} />
            <Route path="branch/delivery" element={<BranchDeliveryMan />} />
            <Route path="branch/delivery/create" element={<BranchDeliveryManUpdate />} />
            <Route path="branch/delivery/update/:memberNo" element={<BranchDeliveryManUpdate />} />
            <Route path="sorting" element={<SortingView />} />
            <Route path="area" element={<AreaList />} />
            <Route path="area/address/:areaNo" element={<AreaAddressList />} />
            <Route path="tariff" element={<TariffList />} />
            <Route path="tariff/create" element={<TariffUpdate />} />
            <Route path="tariff/update/:tariffNo" element={<TariffUpdate />} />
          </Route>
          <Route path="*" element={<AdminLayout />}>
            <Route path="*" element={<EmptyPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    );
  }
};

export default XpressRouter;
